function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.closest('details').hasAttribute('open')) {
      document.body.classList.remove('header-menu-open');
    } else {
      document.body.classList.add('header-menu-open');
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  document.body.classList.remove('header-menu-open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (!this.closest('.product-form__input')) {
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.input.disabled = true;    
          this.input.disabled = false;
        }
      })
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`, 'header-menu-open', 'header-menu-open-secondary');
    if (summaryElement.classList.contains('product-info-drawer__open-wrapper')) {
      document.querySelector('.product__info-container').classList.add('extra-z-index');
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden`, 'header-menu-open', 'header-menu-open-secondary');
    removeTrapFocus(elementToFocus);
    if (this.classList.contains('product-info-drawer__wrapper')) {
      document.querySelector('.product__info-container').classList.remove('extra-z-index');
    }
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    if (detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.announcementBar = this.announcementBar || document.getElementById('shopify-section-announcement-bar');
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.announcementBar.getBoundingClientRect().bottom - this.borderOffset)}px`);
    } else {
      document.documentElement.style.setProperty('--header-bottom-position', '0px');
    }
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`, 'header-menu-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.currentIndex = -1;
    this.dots = this.querySelector('.slider-dots');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.dots) {
      const newIndex = this.currentPage - 1;
      const visibleDots = this.dots.querySelectorAll('.slider-dots__dot:not(.hidden)');
      const selectedDot = visibleDots[newIndex];
      visibleDots.forEach((dot) => dot.classList.remove('is-active'));
      if (selectedDot) {
        selectedDot.classList.add('is-active');
      }
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Set the height of the gallery on slide change
    if (this.hasAttribute('data-set-height')) {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

      if (vw < 750) {
        const atSnappingPoint = this.slider.scrollLeft % this.slider.offsetWidth === 0;
        const timeOut = atSnappingPoint ? 0 : 150;
        const self = this;

        clearTimeout(this.slider.scrollTimeout);
        this.slider.scrollTimeout = setTimeout(function() {
          const newIndex = self.currentPage - 1;
          if (self.currentIndex != newIndex) {
            self.currentIndex = newIndex;
            const allVisibleSlides = Array.from(self.sliderItems).filter(element => element.clientWidth > 0);
            const currentSlide = allVisibleSlides[self.currentIndex];
            const currentSlideHeight = currentSlide.querySelector('modal-opener').offsetHeight;
  
            // self.slider.style.height = `${currentSlideHeight}px`;
          }
        }, timeOut);
      } else {
        // this.slider.style.height = 'auto';
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

function openStoreAvailability(event) {
  const storeAvailabilityElement = document.querySelector('.product-stores')
  if (storeAvailabilityElement) {
    if (storeAvailabilityElement.closest('quick-add-modal')) {
      window.location = event.target.closest('form').dataset.variantLink;
      return;
    }
    const storeAvailabilityAccordion = storeAvailabilityElement.closest('details');
    storeAvailabilityAccordion.setAttribute('open', '');
    storeAvailabilityAccordion.scrollIntoView(true);
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', (event) => this.onVariantChange(event));
    // this.updateDisabledVariantPickers();
  }

  onVariantChange(event) {
    if (event.target.closest('.mobile-size-picker')) {
      this.updateOptionsMobile();
    } else {
      this.updateOptions();
    }
    this.updateMasterId();
    this.updateBackInStockButton();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateColorSection();
      this.updateShareUrl();
    }
  }
  updateOptionsMobile() {
    let sizeOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const fieldsets = Array.from(this.querySelectorAll('fieldset.color-input'));
    let colorOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    this.options = [...colorOptions, ...sizeOptions];
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    // if size variant does not exist, pick the first variant of same color
    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.option1 === this.options[0];
      });
    }

    // if color variant does not exist, pick the first variant of same size
    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.option1 === this.options[0];
      });
    }
    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: this.currentVariant } }))
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const additionalMedia = document.querySelectorAll('.product__media-item[data-media-skus]');

    let mediaFound = false;
    additionalMedia.forEach(media => {
      console.log(media.dataset.mediaSkus)
      const mediaSkusArray = media.dataset.mediaSkus.split('; ').map(sku => {
        let str = sku;
        console.log(str);
        if (media.dataset.mediaSkus.indexOf('Makia x Kummeli') != -1) {
          return str.split('<>')[0]
        } else {
          const lastIndex = str.lastIndexOf('_');

          if (lastIndex != -1) {
            const replacement = '<>';
            str =
              str.slice(0, lastIndex) +
              replacement +
              str.slice(lastIndex);
          }
          return str.split('<>')[0]
        }

      });
      console.log(mediaSkusArray)
      console.log(this.currentVariant.sku)
      if (mediaSkusArray.includes(this.currentVariant.sku)) {
        console.log(media);
        media.classList.remove('hidden');
        mediaFound = true;
      } else {
        media.classList.add('hidden');
      }
    });
    if (!mediaFound) {
      additionalMedia[0].classList.remove('hidden');
    }

    const dots = document.querySelectorAll('.slider-dots__dot');

    if (dots) {
      const visibleDots = document.querySelectorAll('.slider-dots__dot:not(.hidden)');
      dots.forEach((dot) => dot.classList.remove('is-active'));
      if (visibleDots && visibleDots[0]) {
        visibleDots[0].classList.add('is-active');
      }
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateBackInStockButton() {
    const productInfo = this.closest('.product__info-container') || document;
    const button = productInfo.querySelector('#BIS_trigger');
    if (!button) return;

    const variant = this.currentVariant;
    if (variant && variant.available) {
      button.style.display = 'none';
    } else if (variant) {
      button.style.display = '';
      button.setAttribute('data-variant-id', variant.id);
    } else {
      button.style.display = 'none';
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateDisabledVariantPickers() {
    const variantPickers = document.querySelectorAll('.product-form__input input[data-option]');

    if (variantPickers) {
      variantPickers.forEach(element => {
        const elementLabel = element.nextElementSibling;
        if (element.disabled && elementLabel && elementLabel.classList.contains('size-picker-label')) {
          elementLabel.addEventListener('click', (e) => openStoreAvailability(e));
        } else if (elementLabel && elementLabel.classList.contains('size-picker-label')) {
          elementLabel.removeEventListener('click', (e) => openStoreAvailability(e))
        }
      });
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const priceDestination = document.getElementById(`price-${this.dataset.section}`);
        const priceSource = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        
        const variantPickerDestination = document.querySelector('variant-radios');
        const variantPickerSource = html.querySelector('variant-radios');
        
        const inventoryQuantityDestination = document.querySelector('.inventory-quantity');
        const inventoryQuantitySource = html.querySelector('.inventory-quantity');

        const quantityAndBuyButtonsDestination = document.querySelector('.quantity-and-buy-buttons');
        const quantityAndBuyButtonsSource = html.querySelector('.quantity-and-buy-buttons');
        
        const storeAvailabilityDestination = document.querySelector('.product-stores');
        const storeAvailabilitySource = html.querySelector('.product-stores');

        const productTypeDestination = document.querySelector('.product .product__info-wrapper .product-type');
        const productTypeSource = html.querySelector('.product .product__info-wrapper .product-type');

        const ctaPriceDestination = document.querySelector('.product-cta-sticky__price');
        const ctaPriceSource = html.querySelector('.product-cta-sticky__price');

        const ctaButtonDestination = document.querySelector('.product-cta-sticky__button');
        const ctaButtonSource = html.querySelector('.product-cta-sticky__button');

        const productCodeDestination = document.querySelector('.product-code');
        const productCodeSource = html.querySelector('.product-code');

        const variantInfoTextDestination = document.querySelector('.variant-info-text');
        const variantInfoTextSource = html.querySelector('.variant-info-text');

        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
        if (inventoryQuantitySource && inventoryQuantityDestination) inventoryQuantityDestination.innerHTML = inventoryQuantitySource.innerHTML;
        if (quantityAndBuyButtonsSource && quantityAndBuyButtonsDestination) quantityAndBuyButtonsDestination.innerHTML = quantityAndBuyButtonsSource.innerHTML;
        if (storeAvailabilitySource && storeAvailabilityDestination) storeAvailabilityDestination.innerHTML = storeAvailabilitySource.innerHTML;
        if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
        if (productTypeSource && productTypeDestination) productTypeDestination.innerHTML = productTypeSource.innerHTML;
        if (productCodeSource && productCodeDestination) productCodeDestination.innerHTML = productCodeSource.innerHTML;
        if (variantInfoTextSource && variantInfoTextDestination) variantInfoTextDestination.innerHTML = variantInfoTextSource.innerHTML;
        if (!variantInfoTextSource && variantInfoTextDestination) variantInfoTextDestination.innerHTML = '';
        const price = document.getElementById(`price-${this.dataset.section}`);

        const applyFClub = new CustomEvent('fClub:applyFClubAll');
        document.dispatchEvent(applyFClub);
        if (price) price.classList.remove('visibility-hidden');
        const disable = this.currentVariant && this.currentVariant.available ? false : true
        this.toggleAddButton(disable, window.variantStrings.soldOut);
        
        if (ctaPriceSource && ctaPriceDestination) ctaPriceDestination.innerHTML = ctaPriceSource.innerHTML;
        if (ctaButtonSource && ctaButtonDestination) ctaButtonDestination.innerHTML = ctaButtonSource.innerHTML;

        // Update sticky button visibility based on hide_buy_button metafield
        const stickyButtonContainer = document.querySelector('.product-cta-sticky');
        const stickyButtonContainerSource = html.querySelector('.product-cta-sticky');
        if (stickyButtonContainer && stickyButtonContainerSource) {
          const hideBuyButton = stickyButtonContainerSource.dataset.hideBuyButton;
          if (hideBuyButton === 'true') {
            stickyButtonContainer.style.display = 'none';
          } else {
            stickyButtonContainer.style.display = '';
          }
          stickyButtonContainer.dataset.hideBuyButton = hideBuyButton;
        }

        // Update main buy buttons visibility based on hide_buy_button metafield
        const mainBuyButtonContainer = document.querySelector('.quantity-and-buy-buttons');
        const mainBuyButtonContainerSource = html.querySelector('.quantity-and-buy-buttons');
        if (mainBuyButtonContainer && mainBuyButtonContainerSource) {
          const hideBuyButton = mainBuyButtonContainerSource.dataset.hideBuyButton;
          if (hideBuyButton === 'true') {
            mainBuyButtonContainer.style.display = 'none';
          } else {
            mainBuyButtonContainer.style.display = '';
          }
          mainBuyButtonContainer.dataset.hideBuyButton = hideBuyButton;
        }

        this.updateDisabledVariantPickers();

        const saleBadge = html.querySelector('.price__badge-sale');
        const imageSaleBadge = document.querySelector('.main-product-badge-sale');
        if (saleBadge) {
          if (imageSaleBadge) {
            imageSaleBadge.innerHTML = saleBadge.innerHTML;
          }
        } else {
          if (imageSaleBadge) {
            imageSaleBadge.innerHTML = '';
          }
        }

        // HULK 17th JAN
        window.hulkappsStart($);

        document.dispatchEvent(new Event('product:render-info'));
      });
  }

  updateColorSection() {
    const colorSection = document.getElementById('colors-of-finland-color');
    if (colorSection) {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${colorSection.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const colorSource = html.getElementById('colors-of-finland-color');
        if (colorSource) colorSection.innerHTML = colorSource.innerHTML;
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    let sizeOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    let colorOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    this.options = [...colorOptions, ...sizeOptions];
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Make elements sticky inside containers (and also scrollable)
const stickyElements = document.querySelectorAll('.is-sticky')
if (stickyElements.length) {
  for (let i = 0; i < stickyElements.length; i += 1) {
    const stickyElement = stickyElements[i];
    stickyElement.lastKnownY = window.scrollY;
    stickyElement.currentTop = 0;
    window.addEventListener('scroll', function() {
      if (window.innerWidth > 749) {
        const bounds = stickyElement.getBoundingClientRect(),
        maxTop = bounds.top + window.scrollY - stickyElement.offsetTop,
        minTop = stickyElement.clientHeight - window.innerHeight;

        if (window.scrollY < stickyElement.lastKnownY) {
          stickyElement.currentTop -= window.scrollY - stickyElement.lastKnownY;
        } else {
          stickyElement.currentTop += stickyElement.lastKnownY - window.scrollY;
        }

        stickyElement.currentTop = Math.ceil(Math.min(Math.max(stickyElement.currentTop, -minTop), maxTop, 0));
        stickyElement.lastKnownY = window.scrollY;

        stickyElement.style.top = stickyElement.currentTop + 'px';
      }
    });
  }
}

const collectionLayoutSwitchers = document.querySelectorAll('[data-action="change-layout-mode"]');

if (collectionLayoutSwitchers) {
  collectionLayoutSwitchers.forEach(element => {
    element.addEventListener('click', (event) => {
      var layoutType = event.target.getAttribute('data-grid-type'),
          newCount = parseInt(event.target.getAttribute('data-count'));

      // Otherwise we detect the mode, and change all classes
      var productList = document.querySelector('#product-grid');

      if (productList) {
        var previousCount = parseInt(productList.getAttribute('data-' + layoutType + '-count'));

        if (previousCount === newCount) {
          return; // Nothing has changed so we just return to avoid reflow
        }
        productList.classList.forEach(classItem => {
          if (classItem.includes('col-desktop')) {
            productList.classList.remove(classItem)
          }
        });
        
        productList.classList.add('grid--' + newCount + '-col-desktop');
        productList.setAttribute('data-' + layoutType + '-count', newCount);
      }

      collectionLayoutSwitchers.forEach(element => {
        element.classList.remove('is-active')
      });
      event.target.classList.add('is-active');


      // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
      // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

      fetch(routes.cart_url + '/update.js', {
        body: JSON.stringify({
          attributes: { ['collection_' + layoutType + '_items_per_row']: newCount }
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      });
    });
  });
}

var additional_nav = document.getElementsByClassName("additional-children");
var i;

for (i = 0; i < additional_nav.length; i++) {
  additional_nav[i].addEventListener("click", function() {
    this.classList.toggle("panel-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

const headerSearch = document.querySelector('.header__search');
let searchResultsLoadStarted = false;

if (headerSearch) {
  // headerSearch.addEventListener('click', fetchTrending, false)
}

document.addEventListener('DOMContentLoaded', (event) => {
  // fetchTrending();
})

let cachedProductRecommendationsHtml = document.querySelector('.product-results');
let cachedCategoryRecommendationsHtml = document.querySelector('.category-results');

function fetchTrending() {
  if (!searchResultsLoadStarted) {
    searchResultsLoadStarted = true;
    var data = {
      recommendationType: "trending-products",
      limit: 7
    };

    const formBody = Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');

    fetch("https://services.mybcapps.com/discovery/recommend?shop=finlaysonfi.myshopify.com", {
      "method": "POST",
      "headers": {
        "Accept": "*/*",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      "body": formBody
    })
    .then(response => response.json())
    .then((json) => {
      const productRecommendations = json.products;
      const productRecommendationsContainer = document.querySelector('.product-results');

      const productRecommendationsHtml = productRecommendations.map(item => {
        const productPattern = item.metafields.find(metafield => metafield.key === 'pattern') ? item.metafields.find(metafield => metafield.key === 'pattern').value : item.title;
        let productImage = null;
        if (item.variants && item.variants.length > 0 && item.variants[0].image) {
          productImage = item.variants[0].image;
        } else if (item.images && item.images[1]) {
          productImage = item.images[1];
        }
        return `<div class="card-wrapper product-card-wrapper card-wrapper--sold-out">
          <div class="card card--standard card--media" style="--ratio-percent: 142.85714285714286%;">
            <div class="card__inner ratio">
              <div class="card__media">
              ${productImage ? `<div class="media media--transparent media--hover-effect">
        
              <img src="${productImage}"
                alt="${item.title}" class="motion-reduce" loading="lazy" width="100" height="120">
            </div>` : ''}
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                <a href="/products/${item.handle}" class="full-unstyled-link">
                  ${productPattern ? `<span class="product-pattern-name">${productPattern}</span>` : ''}
                  <span class="product-type">${productPattern ? item.title.replace(productPattern, '') : item.title}</span>
                </a>
                </h3>
              </div>
            </div>
          </div>
        </div>`
      }).join('');
      productRecommendationsContainer.innerHTML = productRecommendationsHtml;
    })
    .catch(err => {
      console.error(err);
    });
  }
}

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

const headerSearchInput = document.querySelector('#header-search');

function search() {
  const productResultsContainer = document.querySelector('.suggestions-results--products');
  const categoryResultsContainer = document.querySelector('.suggestions-results--categories');

  if (!headerSearchInput.value) {
    const fullProductsHtml = `<div class="suggestions-heading">
    <span>${window.searchStrings.productSuggestions}</span>
    </div>
    <div class="product-results">
      ${cachedProductRecommendationsHtml.innerHTML}
    </div>
    `;
    productResultsContainer.innerHTML = fullProductsHtml;

    const fullCategoriesHtml = `<div class="suggestions-heading">
        ${window.searchStrings.popularCategories}
      </div>
      <div class="category-results">
        ${cachedCategoryRecommendationsHtml.innerHTML}
      </div>
    `;
    categoryResultsContainer.innerHTML = fullCategoriesHtml;
  } else {

    fetch("https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=finlaysonfi.myshopify.com&product_limit=7&q=" + headerSearchInput.value)
    .then(response => {
      return response.json();
    }).then((json) => {
      const productsResults = json.products;
      if (!productsResults || productsResults.length === 0) {
        // FIX 
        const fullProductsHtml = `<div class="suggestions-heading">
          <span>${window.searchStrings.productSuggestions}</span>
        </div>
        <div class="product-results">
          ${cachedProductRecommendationsHtml.innerHTML}
        </div>
        `;
        productResultsContainer.innerHTML = fullProductsHtml;
      } else {
        const productResultsHtml = productsResults.map(item => {
          const productPattern = item.metafields.find(metafield => metafield.key === 'pattern') ? item.metafields.find(metafield => metafield.key === 'pattern').value : item.title;
          let productImage = null;
          if (item.variants && item.variants.length > 0 && item.variants[0].image) {
            productImage = item.variants[0].image;
          } else if (item.images && item.images[1]) {
            productImage = item.images[1];
          } else if (item.images && item.images[0]) {
            productImage = item.images[0];
          }
          return `<div class="card-wrapper product-card-wrapper card-wrapper--sold-out">
          <div class="card card--standard card--media" style="--ratio-percent: 142.85714285714286%;">
            <div class="card__inner ratio">
              <div class="card__media">
              ${productImage ? `<div class="media media--transparent media--hover-effect">
        
              <img src="${productImage}"
                alt="${item.title}" class="motion-reduce" loading="lazy" width="100" height="120">
            </div>` : ''}
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a href="/products/${item.handle}" class="full-unstyled-link">
                    ${productPattern ? `<span class="product-pattern-name">${productPattern}</span>` : ''}
                    ${item.variants && item.variants.length > 0 ?
                      `<span class="product-type">${productPattern ? item.variants[0].title !== 'Default Title' ?  item.variants[0].title.replace(productPattern, '') : item.title.replace(productPattern, '') : item.variants[0].title !== 'Default Title' ? item.variants[0].title : item.title}</span>`
                    :  
                      `<span class="product-type">${productPattern ? item.title.replace(productPattern, '') : item.title}</span>`
                    }
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </div>`
        }).join('');

        const fullProductsHtml = `<div class="suggestions-heading">
          <span>${window.searchStrings.products}</span>
          ${json.total_product > 7 ? `<a href="${routes.search_url}?q=${headerSearchInput.value}" class="full-unstyled-link see-all-results-link see-all-results-link-top">${window.searchStrings.seeAllProducts}</a>` : ''}
        </div>
        <div class="product-results">
          ${productResultsHtml}
        </div>
        ${json.total_product > 7 ? `<a href="${routes.search_url}?q=${headerSearchInput.value}" class="full-unstyled-link see-all-results-link see-all-results-link-bottom">${window.searchStrings.seeAllProducts}</a>` : ''}
        `;

        productResultsContainer.innerHTML = fullProductsHtml;
      }

      const categoryResults = json.collections;
      if (!categoryResults || productsResults.length === 0) {
        const fullCategoriesHtml = `<div class="suggestions-heading">
            ${window.searchStrings.popularCategories}
          </div>
          <div class="category-results">
            ${cachedCategoryRecommendationsHtml.innerHTML}
          </div>
        `;
        categoryResultsContainer.innerHTML = fullCategoriesHtml;
      } else {
        const categoryResultsHtml = categoryResults.map(item => 
          `<div class="category-suggestion">
              <a href="/collections/${item.handle}" class="full-unstyled-link">${item.title}</a>
          </div>`
        ).join('');

        const fullCategoriesHtml = `<div class="suggestions-heading">
            ${window.searchStrings.categories}
          </div>
          <div class="category-results">
            ${categoryResultsHtml}
          </div>
        `;
        categoryResultsContainer.innerHTML = fullCategoriesHtml;
      }
    })
    .catch(err => {
      console.error(err);
    });
  }
}

const processHeaderInput = debounce(() => search());

headerSearchInput.addEventListener('keyup', processHeaderInput)

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const searchTerm = urlParams.get('q')

if (searchTerm) {

  fetch("https://services.mybcapps.com/bc-sf-filter/search?shop=finlaysonfi.myshopify.com&limit=70&q=" + searchTerm)
  .then(response => {
    return response.json();
  }).then((json) => {
    const productsResults = json.products;
    const productResultsContainer = document.getElementById('search-product-grid');
    const productResultsHtml = productsResults.map(item => {
      let productPattern = item.metafields.find(metafield => metafield.key === 'pattern') ? item.metafields.find(metafield => metafield.key === 'pattern').value : item.title;
      return item.variants.map(variant => {
        let productImage = null;
        if (variant && variant.image) {
          productImage = variant.image;
        } else if (item.images && item.images[1]) {
          productImage = item.images[1];
        };
        return `<li class="grid__item">
          <div class="card-wrapper product-card-wrapper">
            <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
              <div class="card__inner ratio" style="--ratio-percent: 125.0%;">
                ${productImage ? `<div class="card__media"><div class="media media--transparent media--hover-effect">
                  <img src="${productImage}" alt="${variant.title}" class="motion-reduce" width="800" height="538"></div></div>
                ` : ''}
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading">
                      <a href="/products/${variant.handle}" class="full-unstyled-link">
                        ${productPattern ? `<span class="product-pattern-name">${productPattern}</span>` : ''}
                        <span class="product-type">${productPattern ? variant.title !== 'Default Title' ?  variant.title.replace(productPattern, '') : item.title.replace(productPattern, '') : variant.title !== 'Default Title' ? variant.title : item.title}</span>
                      </a>
                    </h3>
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5">
                    <a href="/products/${item.handle}?variant=${variant.id}" class="full-unstyled-link">
                      ${productPattern ? `<span class="product-pattern-name">${productPattern}</span>` : ''}
                      <span class="product-type">${productPattern ? variant.title !== 'Default Title' ?  variant.title.replace(productPattern, '') : item.title.replace(productPattern, '') : variant.title !== 'Default Title' ? variant.title : item.title}</span>
                    </a>
                  </h3>
                  <div class="card-information">
                    <div class="price${!variant.available ? ' price--sold-out' : ''}${variant.price < variant.compare_at_price ? ' price--on-sale' : ''} price--show-badge">
                      <div class="price__container">
                        <div class="price__regular">
                          <span class="visually-hidden visually-hidden--inline">Normaalihinta</span>
                          <span class="price-item price-item--regular">
                            ${variant.price.replace('.', ',')} €
                          </span>
                        </div>
                        <div class="price__sale">
                          <span class="visually-hidden visually-hidden--inline">Myyntihinta</span>
                          <span class="price-item price-item--sale price-item--last">
                            ${variant.price.replace('.', ',')} €
                          </span>
                          <span class="visually-hidden visually-hidden--inline">Normaalihinta</span>
                          <span>
                            <s class="price-item price-item--regular">
                              ${variant.compare_at_price ? variant.compare_at_price.replace('.', ',') : variant.price.replace('.', ',')} €
                            </s>
                          </span>
                        </div>
                      </div>
                      ${!variant.available ? '<div class="badge price__badge-sale price__badge-sold-out">Tilapäisesti loppu - Katso myymäläsaatavuus</div>' : ''}
                    </div>
        
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>`
      }).join('');
    }).join('');

    if (productResultsHtml) {
      productResultsContainer.innerHTML = productResultsHtml;
    } else {
      productResultsContainer.innerHTML = `<div class="no-results-container"><p role="status">${window.searchStrings.noResults}</p></div>`;
    }
  })
  .catch(err => {
    console.error(err);
  });
}

const getOffsetTop = element => {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

// Product sticky cta
const productStickyCTA = document.querySelectorAll('.product-cta-sticky')
if (productStickyCTA.length) {
  for (let i = 0; i < productStickyCTA.length; i += 1) {
    const productStickyCTAElement = productStickyCTA[i];
    let isVisible = false;
    window.addEventListener('scroll', function() {
      const windowTop = window.scrollY;
      const windowBottom = windowTop + window.innerHeight;

      const start = getOffsetTop(document.querySelector('.quantity-and-buy-buttons')) + document.querySelector('.quantity-and-buy-buttons').offsetHeight;
      const end = document.querySelector('#shopify-section-footer').offsetTop;

      if (windowTop >= start && windowBottom < end && isVisible == false) {
        productStickyCTAElement.classList.add('is-visible');
        isVisible = true;
      }

      if (windowTop < start || windowBottom > end && isVisible == true) {
        productStickyCTAElement.classList.remove('is-visible');
        isVisible = false;
      }
    });
  }
  document.addEventListener('click', (e) => {
    const target = e.target.closest(".product-cta-sticky .product-form__submit");

    if(target){
      document.querySelector('.quantity-and-buy-buttons .product-form__submit').click();
    }
  });

  document.addEventListener('product-form:add-start', function () {
    const submitButton = document.querySelector('.product-cta-sticky .product-form__submit');
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  });

  document.addEventListener('product-form:add-end', function () {
    const submitButton = document.querySelector('.product-cta-sticky .product-form__submit');
    submitButton.classList.remove('loading');
    submitButton.removeAttribute('aria-disabled');
    submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  });
}

document.addEventListener('DOMContentLoaded', (event) => {
  const productMedia = document.querySelectorAll('.product__media-item:not(:first-of-type) .product__media img');
  if (productMedia) {
    productMedia.forEach(element => {
      if (element.naturalHeight > 0 && element.naturalWidth > 0) {
        // element.closest('.product__media').style.paddingTop = (1 / (element.naturalWidth / element.naturalHeight) * 100) + '%';
      }
    });
  }
  
  const menuDrawerSearchLink = document.querySelector('.menu-drawer__search');

  if (menuDrawerSearchLink) {
    const searchModal = document.querySelector('.header__search details');
    menuDrawerSearchLink.addEventListener('click', () => {
      searchModal.setAttribute('open', true)
    })
  }
})

// Simple toolbar - just make it sticky, no complex scroll behavior
const toolbar = document.querySelector(".toolbar");
if (toolbar) {
  // Remove all complex scroll classes and just keep it simple
  toolbar.classList.remove("scrolling-down", "scrolling-up");
}

document.addEventListener('DOMContentLoaded', (event) => {
  var hr = new Headroom(document.body);
  hr.init();
});

(function () {
  function formatPerkLine(p) {
    // If the value is just a checkmark, show the label instead
    // (a checkmark with no label is meaningless on its own).
    if (p.value === '✓') return p.label;
    // Otherwise combine label + value, e.g. "Synttärilahja 20 € + 100 pistettä"
    return p.label + ' ' + p.value;
  }

  function buildCards() {
    var table = document.querySelector('.rivo-vip-tier-table');
    if (!table || table.dataset.cardified) return;

    var headerCells = Array.from(
      table.querySelectorAll('.rivo-vip-tier-table-thead-row > th')
    ).filter(th => th.querySelector('.rivo-th-cell-content'));

    var rows = Array.from(
      table.querySelectorAll('.rivo-vip-tier-table-tbody-row')
    );

    // Bail out until Rivo has actually rendered real data.
    // (Guards against running on an empty/template-only table.)
    var hasHeaderData = headerCells.length > 0 &&
      headerCells.every(th => th.querySelector('.rivo-th-tier-name')?.textContent.trim());
    var hasRowData = rows.length > 0 &&
      rows.some(row =>
        Array.from(row.querySelectorAll('.rivo-vip-tier-table-row-perk-value'))
          .some(cell => cell.textContent.trim())
      );

    if (!hasHeaderData || !hasRowData) return; // try again on next mutation

    var RATE_PERK_LABEL = 'Pisteitä ostoista';

    var tiers = headerCells.map(function (th) {
      return {
        icon: th.querySelector('.rivo-th-tier-image')?.innerHTML || '',
        name: th.querySelector('.rivo-th-tier-name')?.textContent.trim() || '',
        threshold: th.querySelector('.rivo-th-tier-threshold')?.textContent.trim() || '',
        active: th.classList.contains('rivo-vip-tier-active'),
        perks: []
      };
    });

    rows.forEach(function (row) {
      var label = row.querySelector('.rivo-vip-tier-table-row-perk-name')?.textContent.trim();
      var valueCells = row.querySelectorAll('.rivo-vip-tier-table-row-perk-value');
      valueCells.forEach(function (cell, i) {
        if (tiers[i]) {
          tiers[i].perks.push({ label: label, value: cell.textContent.trim() });
        }
      });
    });

    var container = document.createElement('div');
    container.className = 'rivo-vip-cards';

    tiers.forEach(function (tier, idx) {
      var card = document.createElement('div');
      card.className = 'rivo-vip-card' + (tier.active ? ' rivo-vip-card-active' : '');

      var rateEntry = tier.perks.find(p => p.label === RATE_PERK_LABEL);
      var prevTier = tiers[idx - 1];
      var prevPerksMap = {};
      if (prevTier) {
        prevTier.perks.forEach(p => (prevPerksMap[p.label] = p.value));
      }

      var listItems = [];

      if (idx === 0) {
        tier.perks.forEach(function (p) {
          if (p.label !== RATE_PERK_LABEL && p.value) {
            listItems.push('<li>' + formatPerkLine(p) + '</li>');
          }
        });
      } else {
        listItems.push(
          '<li class="rivo-inherit-line">Nautit kaikista ' + prevTier.name + '-eduista, lisäksi:</li>'
        );
        tier.perks.forEach(function (p) {
          if (
            p.label !== RATE_PERK_LABEL &&
            p.value &&
            p.value !== prevPerksMap[p.label]
          ) {
            listItems.push('<li>' + formatPerkLine(p) + '</li>');
          }
        });
      }

      card.innerHTML =
        '<div class="rivo-vip-card-icon">' + tier.icon + '</div>' +
        '<h3 class="rivo-vip-card-name">' + tier.name + '</h3>' +
        '<p class="rivo-vip-card-threshold">' + tier.threshold + '</p>' +
        (rateEntry ? '<p class="rivo-vip-card-points-rate">Pisteet ostoista ' + rateEntry.value + '</p>' : '') +
        '<ul class="rivo-vip-card-list">' + listItems.join('') + '</ul>';

      container.appendChild(card);
    });

    // Only now, once cards actually exist, do we hide the table.
    table.parentNode.insertBefore(container, table);
    table.classList.add('rivo-cards-active');
    table.dataset.cardified = 'true';

    // Data won't change again after initial render, so stop watching.
    observer.disconnect();
  }

  var observer = new MutationObserver(buildCards);
  observer.observe(document.body, { childList: true, subtree: true });

  // Also try on load and via a couple of delayed fallbacks,
  // in case Rivo renders after DOMContentLoaded but without
  // triggering a mutation the observer catches in time.
  document.addEventListener('DOMContentLoaded', buildCards);
  setTimeout(buildCards, 1000);
  setTimeout(buildCards, 3000);
})();

//account card modification
(function () {
  function buildAccountLayout() {
    var card = document.querySelector('#rivo-account-dashboard .rivo-account-card-content');
    if (!card || card.dataset.splitBuilt) return;

    var pointsSpan = card.querySelector('.rivo-account-card-title span[rivo-x-text="$store.customer.pretty_points_tally"]');
    var tierSpan = card.querySelector('.rivo-account-card-subtitle span');

    // Wait until Rivo has actually rendered real values, not just
    // template defaults / skeleton state.
    if (!pointsSpan || !pointsSpan.textContent.trim()) {
      return; // try again on next check
    }

    var wrapper = document.querySelector('#rivo-account-dashboard .rivo-account-content');

    if (!wrapper) return;

    // ---- Wrap existing content in a text column ----
    var textCol = document.createElement('div');
    textCol.className = 'rivo-account-text-col';
    while (wrapper.firstChild) {
      textCol.appendChild(wrapper.firstChild);
    }
    wrapper.appendChild(textCol);
    wrapper.classList.add('rivo-account-content-split');

    // ---- Add the image column ----
    var imageCol = document.createElement('div');
    imageCol.className = 'rivo-account-image-col';
    imageCol.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/2293/7935/files/Finlayson-F-Club-hero-2026.png?v=1787566453" alt="" class="rivo-account-image" loading="lazy">';
    wrapper.appendChild(imageCol);

    // ---- Restyle the CTA link ----
    var cta = textCol.querySelector('.rivo-account-card-content-footer a');
    if (cta) cta.classList.add('rivo-account-cta-link');

    card.dataset.splitBuilt = 'true';
  }

  var observer = new MutationObserver(buildAccountLayout);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('DOMContentLoaded', buildAccountLayout);
  setTimeout(buildAccountLayout, 1000);
  setTimeout(buildAccountLayout, 3000);
})();

if (window.location.pathname.includes('/apps/ba-loy/wallet')) {
  (function () {
    const t = window.walletPassTranslations || {};
    const translations = {
      'Get your Wallet Pass': t.title,
      'Scan the QR code above to add your wallet pass to your device.': t.instructions,
      'Click the button below to add your wallet pass to your device.': t.buttonInstructions,
      'Access your Pass': t.buttonLabel
    };

    function translateNode(node) {
      const text = node.nodeValue;
      const trimmed = text.trim();
      if (translations[trimmed]) {
        node.nodeValue = text.replace(trimmed, translations[trimmed]);
      }
    }

    function walkAndTranslate(root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parentTag = node.parentElement?.tagName;
          if (['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parentTag)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      let n;
      while ((n = walker.nextNode())) translateNode(n);
    }

    walkAndTranslate(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            translateNode(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            walkAndTranslate(node);
          }
        });
        if (mutation.type === 'characterData' && mutation.target.nodeType === Node.TEXT_NODE) {
          translateNode(mutation.target);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  })();
}